import { createActions, createReducer } from "reduxsauce";
import { get, set, cloneDeep, forEach, isEmpty } from "@utils/lodash";

export { default as thunks } from "./thunks";

/* ------------- Initial State ------------- */
export const INITIAL_STATE = {
	ranks: [],
	officers: [],
	counts: {},
	totalCount: 0,
	jurisdictionName: null,
	details: {},
	filters: {
		displayCount: 25,
		pageNumber: 1,
		name: "",
		vettedStatus: "",
		profileCompleted: null,
		stateId: null,
		jurisdictionId: null,
		includeInactive: false,
		sortBy: "id",
		asc: false,
		includeNonJurisdiction: false,
	},
	loaders: {
		officers: false,
		counts: false,
		ranks: false,
		details: false,
		jobHistory: false,
	},
};

/* ------------- Types and Action Creators ------------- */
export const { Types, Creators } = createActions(
	{
		receiveData: ["collection"],
		updateLoaders: ["loader", "value"],
		resetData: ["collection"],
		updateFilters: ["collection"],
		resetFilters: null,
		resetJurisdictionName: ["property"],
	},
	{ prefix: "@officers/" },
);

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
	[Types.RECEIVE_DATA]: (state, { collection }) => {
		if (!isEmpty(collection)) {
			const newState = cloneDeep(state);

			forEach(collection, ({ property, value }) => {
				set(newState, property, value);
			});

			return newState;
		}
		return state;
	},

	[Types.UPDATE_LOADERS]: (state, { loader, value }) => {
		const newState = cloneDeep(state);

		set(newState, ["loaders", loader], value);

		return newState;
	},

	[Types.RESET_DATA]: (state, { collection }) => {
		const newState = cloneDeep(state);

		forEach(collection, property => {
			set(newState, property, get(INITIAL_STATE, property));
		});

		return newState;
	},

	[Types.UPDATE_FILTERS]: (state, { collection }) => {
		const newState = cloneDeep(state);

		forEach(collection, ({ property, value }) => {
			set(newState, `filters.${property}`, value);
		});

		return newState;
	},

	[Types.RESET_FILTERS]: state => ({
		...state,
		filters: INITIAL_STATE.filters,
	}),

	[Types.RESET_JURISDICTION_NAME]: state => {
		const newState = cloneDeep(state);
		newState.jurisdictionName = null;

		return newState;
	},
});

export default Creators;
